'use strict';
import {SettingsViewHeader} from './components/SettingsViewHeader';
import {SettingsViewUploadsHeader} from './components/SettingsViewUploadsHeader';
import {AppSettingsController} from './controllers/AppSettingsController';
import {FileCacheController} from './controllers/FileCacheController';
import {PendingUploadsController} from './controllers/PendingUploadsController';
import {routerConfig} from './router';
import {ApiVersionCheckService} from './services/ApiVersionCheckService';
import {$settingsProvider} from './services/AppSettingsService';


const angular = require('angular');

module.exports = angular
  .module('app.settings', [])
  .config(routerConfig)

  .service('ApiVersionCheckService', ApiVersionCheckService)
  .provider($settingsProvider.SERVICE_NAME, $settingsProvider)

  .controller("AppSettingsController", AppSettingsController)
  .controller("FileCacheController", FileCacheController)
  .controller("PendingUploadsController", PendingUploadsController)
  .directive('settingsViewHeader', ['reactDirective', reactDirective => reactDirective(SettingsViewHeader)])
  .directive('settingsViewUploadsHeader', ['reactDirective', reactDirective =>
    reactDirective(SettingsViewUploadsHeader),
  ])
;



// WEBPACK FOOTER //
// ./src/js/settings/index.js